import get from 'lodash/get';
import intersection from 'lodash/intersection';

export default function hasPermissions(document, user, permissionToCheck) {
  const documentAccess = document.access;
  const userId = user.user_id;
  const userGroups = user.groups;
  const accessSpecification = get(documentAccess, permissionToCheck, {});
  if (!accessSpecification) {
    return false;
  }
  return (
    (accessSpecification.users &&
      accessSpecification.users.includes(userId)) ||
    intersection(accessSpecification.groups, userGroups).length !== 0
  );
}